"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useDebouncedController = void 0;
const react_hook_form_1 = require("react-hook-form");
const use_debounce_1 = require("./use-debounce");
const useDebouncedController = ({ control, name, ms, }) => {
    const controller = (0, react_hook_form_1.useController)({ control, name });
    const { value, onChange } = (0, use_debounce_1.useDebounce)({
        onChange: controller.field.onChange,
        value: controller.field.value,
        ms,
    });
    return {
        field: {
            value,
            onChange,
            name: controller.field.name,
            ref: controller.field.ref,
            onBlur: controller.field.onBlur,
        },
        fieldState: controller.fieldState,
        formState: controller.formState,
    };
};
exports.useDebouncedController = useDebouncedController;
